var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (message) {
buf.push("<h3>" + (jade.escape(null == (jade_interp = message) ? "" : jade_interp)) + "</h3><p>You can always change this in your profile settings.</p><div class=\"stacked-button-menu\"><a href=\"#\" class=\"avant-garde-button-dark make-public\">Yes</a><a href=\"#\" class=\"avant-garde-button-dark cancel\">Cancel</a></div>");}.call(this,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined));;return buf.join("");
};
module.exports = template;